import { render } from "./AssignmentStatus.vue?vue&type=template&id=76896c4e&scoped=true"
import script from "./AssignmentStatus.vue?vue&type=script&lang=js"
export * from "./AssignmentStatus.vue?vue&type=script&lang=js"

import "./AssignmentStatus.vue?vue&type=style&index=0&id=76896c4e&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76896c4e"]])

export default __exports__